<div class="app-header app-container container-fluid d-flex align-items-stretch justify-content-between">
    <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center d-lg-none ms-n2 me-2" title="Show sidebar menu" (click)="onHideShow()">
            <div class="d-flex align-items-center justify-content-center w-35px h-35px">
                <i class="fa-solid fa-bars fs-3"></i>
            </div>
        </div>
    </div>
    <div class="d-flex align-items-center justify-content-between">
        <div class="app-navbar-item ms-1 ms-md-4">
            <div class="d-flex align-items-center justify-content-center w-35px h-35px cursor-pointer">
                <i class="fa fa-bell fs-4"></i>
                <span
                    class="bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink"></span>
            </div>
        </div>
        <div class="app-navbar-item ms-1 ms-md-4 position-relative">
            <div class="d-flex align-items-center justify-content-center w-35px h-35px cursor-pointer profile-toggle"
                (click)="toggleProfilePopup()">
                <i class="fa fa-user fs-4"></i>
            </div>
            <div class="profile-popup" [ngClass]="{'show': showProfilePopup}">
                <div class="profile-header d-flex align-items-center p-3">
                    <div class="profile-avatar">
                        <div class="avatar-icon">
                            <i class="fa-solid fa-user"></i>
                        </div>
                    </div>
                    <div class="profile-info ms-3">
                        <h5 class="mb-1">{{ userData.user_name || 'User' }}</h5>
                        <p class="text-muted mb-0">{{ userData?.user_type_name || 'User' }}</p>
                    </div>
                </div>
                <div class="profile-divider"></div>
                <div class="profile-content p-3">
                    <div class="profile-item d-flex align-items-center mb-2">
                        <i class="fa-solid fa-envelope me-3"></i>
                        <span>{{ userData?.email_address || 'No email available' }}</span>
                    </div>
                    <div class="profile-item d-flex align-items-center mb-2">
                        <i class="fa-solid fa-building me-3"></i>
                        <span>{{ userCompanyName }}</span>
                    </div>
                    <div class="profile-item d-flex align-items-center">
                        <i class="fa-solid fa-phone me-3"></i>
                        <span>{{ userData?.mobile_no || 'No phone available' }}</span>
                    </div>
                </div>
                <div class="profile-divider"></div>
                <div class="profile-footer p-3">
                    <div class="profile-item d-flex align-items-center cursor-pointer logout-item" (click)="logout()">
                        <i class="fa fa-right-from-bracket me-3"></i>
                        <span class="fw-bold">Logout</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

@if (isAdmin && !shouldHideCompanyDropdown && dropdownReady && companyNames && companyNames.length > 0) {
<div class="company-dropdown-container d-flex align-items-center">
    <select id="companySelect" class="form-select form-select-sm" [(ngModel)]="selectedCompany"
        (ngModelChange)="onCompanyChange($event)" style="min-width: 180px; max-width: 250px;">
        @for (company of companyNames; track $index) {
        <option [value]="company.company_name">
            {{company.company_name}}
        </option>
        }
    </select>
</div>
}